import { defineMessages } from 'react-intl-next';

export default defineMessages({
    editDetailsPageBreadcrumbItem: {
        defaultMessage: 'Help centers',
        description: 'Help center edit details page breadcrumb item',
        id: 'edit.details.page.breadcrumb.item',
    },
});
